import { Button } from "primereact/button";

export function WelcomeBannerCarousel(props: any) {

  const onClick = (name: any) => {
    props.dialogFuncMap[`${name}`](true);
  };

  return (
    <div
      className="card border-0 mb-0 pb-0"
      onClick={() => onClick("displayBasic")}     // ⭐ Entire banner clickable
      style={{ cursor: "pointer" }}
    >
      {/* DESKTOP IMAGE */}
      <img
        src={props.web_url}
        className="w-100 img-fluid desktopImage"
        alt="Welcome to TTEC"
      />

      {/* MOBILE IMAGE */}
      <img
        src={props.mobile_url}
        className="w-100 img-fluid mobileImage"
        alt="Welcome to TTEC"
      />

      {/* OVERLAY CONTENT */}
      <div className="card-img-overlay">

        {/* Welcome Text */}
        <div
          className="position-absolute"
          style={{
            top: "20px",
            left: "20px",
            zIndex: 5
          }}
        >
          {props?.profileData?.oracle?.employee?.first_name && (
            <h2 style={{ fontSize: "26px", margin: 0 }}>
              Welcome to TTEC, {props?.displayName}
            </h2>
          )}
        </div>

        {/* Video Button Bottom Right */}
        <div
          className="position-absolute"
          style={{
            bottom: "20px",
            right: "20px",
            zIndex: 5
          }}
        >
          <Button className="youtube p-0">
            <i className="pi pi-youtube p-3"></i>
            <span className="px-2 px-md-3">Watch the welcome video!</span>
          </Button>
        </div>




        {/* WELCOME TEXT (moved UP + adjusted) */}

      </div>
    </div>
  );
}

